import SlackIntegration from './SlackIntegration';
export default SlackIntegration;
